import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
var getClassNameList = classNames.bind(styles);
var UitkSheetTransition = function (props) {
  var children = props.children,
    closeCallback = props.closeCallback,
    _a = props.isVisible,
    isVisible = _a === void 0 ? false : _a,
    openCallback = props.openCallback;
  var baseClassName = 'uitk-sheet';
  return React.createElement(CSSTransition, {
    classNames: {
      enter: getClassNameList("".concat(baseClassName, "-enter")),
      enterActive: getClassNameList("".concat(baseClassName, "-enter-active")),
      exit: getClassNameList("".concat(baseClassName, "-exit")),
      exitActive: getClassNameList("".concat(baseClassName, "-exit-active"))
    },
    in: isVisible,
    unmountOnExit: true,
    timeout: {
      enter: 300,
      exit: 500
    },
    onEntered: openCallback,
    onExited: closeCallback
  }, children);
};
UitkSheetTransition.displayName = 'UitkSheetTransition';
export { UitkSheetTransition };